var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullmakt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "44px",
    viewBox: "0 0 41 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-MEDL-2",
    transform: "translate(-620.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(620.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    fill: "#337C9B"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.3,
    cy: 9.1,
    r: 9.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3,19.5 C22.1976719,19.5 28.6,25.9023281 28.6,33.8 L28.6,37.7 L28.6,37.7 L-1.47792889e-13,37.7 L-1.47792889e-13,33.8 C-1.48760075e-13,25.9023281 6.40232808,19.5 14.3,19.5 Z",
    id: "Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/-feedback/-check-circle-2",
    transform: "translate(18.200000, 22.100000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.92,0 C4.89853,0 0,4.89944 0,10.92 C0,16.94056 4.89853,21.84 10.92,21.84 C16.94056,21.84 21.84,16.94056 21.84,10.92 C21.84,4.89944 16.94056,0 10.92,0 Z",
    id: "Shape",
    fill: "#38A161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77233782,13.1417019 L14.6508372,7.82810714 C15.0077513,7.50477759 15.568972,7.52176407 15.9035175,7.86807387 C16.2382246,8.21455083 16.2190593,8.7581653 15.8614383,9.08224612 L9.35531969,14.9636157 C9.18968388,15.1123437 8.9737021,15.1930435 8.75194241,15.1930435 C8.51899805,15.1930435 8.29506106,15.1051138 8.1249637,14.9420398 L5.95676343,12.8420397 C5.61093393,12.5070882 5.61093393,11.9633167 5.95676343,11.6283652 C6.30259294,11.2934136 6.86402407,11.2934136 7.20985358,11.6283652 L8.77233782,13.1417019 Z",
    id: "Path-Copy",
    fill: "#FFFFFF"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullmakt);
export default __webpack_public_path__ + "static/media/Fullmakt.8bab1bd4ddd02c5fbf4fa92381ce810f.svg";
export { ForwardRef as ReactComponent };